<!-- 项目文件 -->
<template>
    <div class="posre">
            <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w1200 mauto pt50 pb50 overflow">
                <div class=" disinblock w68p floatl">
                    <p class="fs30 c333">2020年小车科目一试题</p>
                    <div class="fs26 c333 mt20">
                        <p class="cursor alit mt25 mb25 borther answerParent ">
                            {{practice.exercise_id}}、
                            {{practice.title}}
                        </p>
                        <div class="fs26 c333 mt20">
                            <p  v-for="(item,index) in choose_listX " :key="index"
                                @click="choose(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther answerParent aaaaa" ref="answerParent">
                                <!-- <img class="w30 h30 answerImg" :src="answerImg" alt="" ref="answerImg"> -->

                                <img v-if="item.T==0" class="w30 h30" src="../../public/img/img68.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==1" class="w30 h30" src="../../public/img/img67.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==2" class="w30 h30" src="../../public/img/img69.png" alt=""
                                    ref="answerImg">
                                <span class="disinblock ml16"> {{item.chose}} </span>
                            </p>
                            <div class="fs16">{{practice.note}}</div>
                        </div>
                        <div v-show="practice.image" class="pl16 pr16 pt20 pb20">
                            <img class="w300 hauto bradius8 " :src="practice.image " alt="">
                        </div>
                        <div class="pt8 pb8 w100p overhidden">
                            <p class="overhidden  mauto">
                                <span @click="last()"
                                    class="border2e bradius25 fs20 cfff  bg1f8  floatl mr20 pl30 pr30 pt12 pb12 cursor">上一题</span>
                                <span @click="next()"
                                    class="border2e bradius25 fs20 disinblock floatl ml20 pl30 pr30 pt12 pb12 cfff bg1f8 cursor">下一题</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                schoolList2: [],
                index: 0,
                practice: { //练习题
                    title: '',
                    note: '',
                    answer: '', //正确答案
                    image: '',
                    title: '',
                    exercise_id: '', //题号
                },
                choose_listX: [], //选项
                practiceList: [],
                chooseList: [],
                typeIndex: 0,
                answerImg: require('../../public/img/img68.png'),
                once: 0,
                Already: [],

            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            getPractice() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                        "order": that.index
                    },
                    success: function(data) {
                        let typeIndex = that.typeIndex;
                        that.practice = data.obj[typeIndex];
                        that.practiceList = data.obj;
                        that.practice.image = data.obj[typeIndex].image;
                        that.practice.answer = data.obj[typeIndex].answer;
                        let arr2 = data.obj[typeIndex].choose_list.split("|");
                        that.practice.note = data.obj[typeIndex].note;
                        for (let i = 0; i < arr2.length; i++) {
                            let P = {
                                chose: arr2[i],
                                T: 0
                            }
                            that.choose_listX.push(P);
                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            next() {
                let that = this;
                if (that.practiceList.length != that.typeIndex + 1) {
                    that.typeIndex++;
                    that.Judgment();
                } else {
                    alert('这已经是最后一题了')
                }

            },
            last() {
                let that = this;
                if (that.typeIndex == 0) {
                    alert('这已经是第一题了')
                } else {
                    that.typeIndex--;
                    that.Judgment();
                }
            },
            Judgment() {

                let that = this;
                //let aa = that.$refs.answerImg;

                this.practice = this.practiceList[this.typeIndex];
                let getAlready = that.$store.state.chooseList;
                console.log(getAlready)
                console.log("正确答案是")
                console.log(this.practice.answer)

                let arr2 = that.practice.choose_list.split("|");

                that.choose_listX = []
                that.markList = []
                let markX = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1,

                };
                for (let i = 0; i < arr2.length; i++) {
                    let P = {
                        chose: arr2[i],
                        T: 0
                    }
                    if (P.chose.indexOf(that.practice.answer) != -1) {
                        console.log(1)
                        P = {
                            chose: arr2[i],
                            T: 1
                        }
                    }
                    that.choose_listX.push(P)
                    that.markList.push(markX)

                }



            },

            choose(item, answer, e, index, practice, index1) {

                let that = this;
                let rigth = '';
                that.once = 1;

                if (item.indexOf(answer) != -1) {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 1
                    }
                    that.choose_listX.splice(index1, 1, P)
                        //e.currentTarget.firstElementChild.src = require('../../public/img/img67.png');
                    rigth = true;
                } else {
                    //e.currentTarget.firstElementChild.src = require('../../public/img/img69.png');
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 2
                    }
                    that.choose_listX.splice(index1, 1, P)
                    for (let i = 0; i < that.choose_listX.length; i++) {
                        if (that.choose_listX[i].chose.indexOf(answer) != -1) {
                            let P = {
                                chose: that.choose_listX[i].chose,
                                T: 1
                            }
                            that.choose_listX.splice(i, 1, P)
                        }
                    }
                    rigth = false;
                }
                let mark = {
                    item: item,
                    index: index,
                    index1: index1,
                    rigthFalse: rigth,
                    answer: answer,
                };

                let getAlready = that.$store.state.chooseList; //取vuex缓存'
                console.log(getAlready)
                if (getAlready.length == 0) {
                    that.Already.push(mark)
                } else {
                    that.Already.splice(index - 1, 1, mark)
                }
                that.$forceUpdate()
                that.$store.dispatch('asyncInrement').then(() => {
                    that.$store.state.chooseList = that.Already;
                });
            },
            tiku() {
                let tiku = this.$route.query.tiku
                this.typeIndex = tiku;
            }

        },


        created() {
            this.tiku();
            this.getPractice();

            this.Judgment();
            this.cityName = this.$store.state.cityName;
        },
        mounted() {
            let that = this;
            if (window.performance.navigation.type == 1) {
                console.log("页面被刷新")
                that.Already = that.$store.state.chooseList;
                that.$forceUpdate()
                that.$store.dispatch('asyncInrement').then(() => {
                    that.$store.state.chooseList = that.Already;
                });
            }
        }
    }
</script>
<style scoped>
    .aaaaa {
        pointer-events: none;
    }
</style>